import { TreasuryTransactionTypeEnum } from '@up/data';
import { IsBoolean, IsNumber, IsOptional, IsString } from 'class-validator';

export class TreasuryBankingSummaryRequestDto {
  @IsNumber()
  businessEntityId: number;

  @IsNumber()
  @IsOptional()
  businessEntityBankId?: number;

  @IsString()
  @IsOptional()
  fromDate?: Date | string;

  @IsString()
  @IsOptional()
  toDate?: Date | string;

  @IsString()
  @IsOptional()
  transactionType?: TreasuryTransactionTypeEnum | undefined;

  @IsString()
  @IsOptional()
  description?: string;

  @IsBoolean()
  @IsOptional()
  updateBalance?: boolean;

  @IsBoolean()
  @IsOptional()
  updateTransactions?: boolean;
}
